import { createAction } from 'redux-actions';

export const GET_CONTEST_LEADERBOARD = 'GET_CONTEST_LEADERBOARD';
export const getContestLeaderboard = createAction(GET_CONTEST_LEADERBOARD);

export const GET_CONTEST_USER_LEADERBOARD = 'GET_CONTEST_USER_LEADERBOARD';
export const getContestUserLeaderboard = createAction(GET_CONTEST_USER_LEADERBOARD);

export const GET_MY_MATCH_TEAM_LIST = 'GET_MY_MATCH_TEAM_LIST';
export const getMyMatchTeamList = createAction(GET_MY_MATCH_TEAM_LIST);

export const JOIN_CONTEST = 'JOIN_CONTEST';
export const joinContest = createAction(JOIN_CONTEST);

export const GET_MY_UPCOMING_MATCHES = 'GET_MY_UPCOMING_MATCHES';
export const getMyUpcomingMatches = createAction(GET_MY_UPCOMING_MATCHES);

export const GET_MY_LIVE_MATCHES = 'GET_MY_LIVE_MATCHES';
export const getMyLiveMatches = createAction(GET_MY_LIVE_MATCHES);

export const GET_MY_COMPLETED_MATCHES = 'GET_MY_COMPLETED_MATCHES';
export const getMyCompletedMatches = createAction(GET_MY_COMPLETED_MATCHES);

export const GET_MY_RECENT_MATCHES = 'GET_MY_RECENT_MATCHES';
export const getMyRecentMatches = createAction(GET_MY_RECENT_MATCHES);

export const GET_MY_FIXTURE_JOINED_CONTEST_LIST = 'GET_MY_FIXTURE_JOINED_CONTEST_LIST';
export const getMyFixtureJoinedContest = createAction(GET_MY_FIXTURE_JOINED_CONTEST_LIST);

export const GET_MY_LIVE_JOINED_CONTEST_LIST = 'GET_MY_LIVE_JOINED_CONTEST_LIST';
export const getMyLiveJoinedContest = createAction(GET_MY_LIVE_JOINED_CONTEST_LIST);

export const GET_MY_RESULT_JOINED_CONTEST_LIST = 'GET_MY_RESULT_JOINED_CONTEST_LIST';
export const getMyResultJoinedContest = createAction(GET_MY_RESULT_JOINED_CONTEST_LIST);

export const FANTASY_MATCH_CLICK = 'FANTASY_MATCH_CLICK';
export const fantasyMatchClick = createAction(FANTASY_MATCH_CLICK);

export const MATCH_ITEM = 'MATCH_ITEM';
export const matchItem = createAction(MATCH_ITEM);

export const UPCOMING_MATCH_LIST = 'UPCOMING_MATCH_LIST';
export const getUpcomingMatchList = createAction(UPCOMING_MATCH_LIST);

export const GET_ALL_CONTEST_LIST = 'GET_ALL_CONTEST_LIST';
export const getAllContestList = createAction(GET_ALL_CONTEST_LIST);

export const GET_MATCH_PLAYER_LIST = 'GET_MATCH_PLAYER_LIST';
export const getPlayerList = createAction(GET_MATCH_PLAYER_LIST);

export const GET_CONTEST_DETAILS_BY_ID = 'GET_CONTEST_DETAILS_BY_ID';
export const getContestDetailsById = createAction(GET_CONTEST_DETAILS_BY_ID);

export const GET_MATCH_DETAILS_BY_ID = 'GET_MATCH_DETAILS_BY_ID';
export const getMatchDetailsById = createAction(GET_MATCH_DETAILS_BY_ID);

export const GET_CONTEST_LIST_BY_CONTEST_TYPE_ID = 'GET_CONTEST_LIST_BY_CONTEST_TYPE_ID';
export const getContestListByContestTypeId = createAction(GET_CONTEST_LIST_BY_CONTEST_TYPE_ID);

export const CONTEST_FILTER = 'CONTEST_FILTER';
export const updateContestFilter = createAction(CONTEST_FILTER);

export const GET_MY_TEAM_DETAILS_BY_TEAM_ID = 'GET_MY_TEAM_DETAILS_BY_TEAM_ID';
export const getMyTeamDetailsByTeamId = createAction(GET_MY_TEAM_DETAILS_BY_TEAM_ID);

export const SWITCH_CONTEST_TEAM = 'SWITCH_CONTEST_TEAM';
export const switchContestTeam = createAction(SWITCH_CONTEST_TEAM);

export const SET_MY_TEAM_LIST = 'SET_MY_TEAM_LIST';
export const setMyTeamList = createAction(SET_MY_TEAM_LIST);

export const SET_ALL_CONTEST_LIST = 'SET_ALL_CONTEST_LIST';
export const setAllContestList = createAction(SET_ALL_CONTEST_LIST);

export const CREATE_TEAM = 'CREATE_TEAM';
export const createTeam = createAction(CREATE_TEAM);

export const EDIT_TEAM = 'EDIT_TEAM';
export const editTeam = createAction(EDIT_TEAM);

export const GET_CONTEST_TYPES = 'GET_CONTEST_TYPES';
export const getContestTypes = createAction(GET_CONTEST_TYPES);

export const SET_CONTEST_TYPES = 'SET_CONTEST_TYPES';
export const setContestTypes = createAction(SET_CONTEST_TYPES);

export const GET_CONTEST_LIST_BY_CONTEST_TYPE = 'GET_CONTEST_LIST_BY_CONTEST_TYPE';
export const getContestListByContestType = createAction(GET_CONTEST_LIST_BY_CONTEST_TYPE);

export const GET_CONTEST_LIST_BY_CATEGORY = 'GET_CONTEST_LIST_BY_CATEGORY';
export const getContestListByCategory = createAction(GET_CONTEST_LIST_BY_CATEGORY);

export const GET_CONTEST_LIST_BY_CATEGORY_ID = 'GET_CONTEST_LIST_BY_CATEGORY_ID';
export const getContestListByCategoryId = createAction(GET_CONTEST_LIST_BY_CATEGORY_ID);

export const JOIN_WITH_MULTIPLE_TEAM = 'JOIN_WITH_MULTIPLE_TEAM';
export const joinWithMultipleTeam = createAction(JOIN_WITH_MULTIPLE_TEAM);

export const GET_CONTEST_CATEGORIES = 'GET_CONTEST_CATEGORIES';
export const getContestCategories = createAction(GET_CONTEST_CATEGORIES);

export const SET_CONTEST_CATEGORIES = 'SET_CONTEST_CATEGORIES';
export const setContestCategories = createAction(SET_CONTEST_CATEGORIES);

export const SET_MY_CONTEST_LIST = 'SET_MY_CONTEST_LIST';
export const setMyContestList = createAction(SET_MY_CONTEST_LIST);

export const GET_MEGA_CONTEST_LEADERBOARD = 'GET_MEGA_CONTEST_LEADERBOARD';
export const getMegaContestLeaderBoard = createAction(GET_MEGA_CONTEST_LEADERBOARD);

export const GET_MY_MEGA_CONTEST_LEADERBOARD = 'GET_MY_MEGA_CONTEST_LEADERBOARD';
export const getMyMegaContestLeaderBoard = createAction(GET_MY_MEGA_CONTEST_LEADERBOARD);

export const GET_SMALL_MEGA_CONTEST_LEADERBOARD = 'GET_SMALL_MEGA_CONTEST_LEADERBOARD';
export const getSmallMegaContestLeaderBoard = createAction(GET_SMALL_MEGA_CONTEST_LEADERBOARD);

export const GET_MY_SMALL_MEGA_CONTEST_LEADERBOARD = 'GET_MY_SMALL_MEGA_CONTEST_LEADERBOARD';
export const getMySmallMegaContestLeaderBoard = createAction(GET_MY_SMALL_MEGA_CONTEST_LEADERBOARD);

export const GET_WEEKEND_CONTEST_LEADERBOARD = 'GET_WEEKEND_CONTEST_LEADERBOARD';
export const getWeekendContestLeaderBoard = createAction(GET_WEEKEND_CONTEST_LEADERBOARD);

export const GET_MY_WEEKEND_CONTEST_LEADERBOARD = 'GET_MY_WEEKEND_CONTEST_LEADERBOARD';
export const getMyWeekendContestLeaderBoard = createAction(GET_MY_WEEKEND_CONTEST_LEADERBOARD);

export const GET_WEEKLY_CONTEST_LEADERBOARD = 'GET_WEEKLY_CONTEST_LEADERBOARD';
export const getWeeklyContestLeaderBoard = createAction(GET_WEEKLY_CONTEST_LEADERBOARD);

export const GET_MY_WEEKLY_CONTEST_LEADERBOARD = 'GET_MY_WEEKLY_CONTEST_LEADERBOARD';
export const getMyWeeklyContestLeaderBoard = createAction(GET_MY_WEEKLY_CONTEST_LEADERBOARD);

export const UPDATE_UPCOMING_MATCHES = 'UPDATE_UPCOMING_MATCHES';
export const updateUpcomingMatches = createAction(UPDATE_UPCOMING_MATCHES);

export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const setInitialData = createAction(SET_INITIAL_DATA);
